export function initLoadBackgroundImages() {
    const images = document.querySelectorAll('[data-background-src]');
    images.forEach((image) => {
        const src = image.getAttribute('data-background-src');
        if (src) {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                image.style.backgroundImage = `url(${src})`;
                image.removeAttribute('data-background-src');
            };
        }
    });
}
